/* LMM · Hinweis „Anmeldung ohne Passwort" am Kundenkonto-Einstieg.
 *
 * Fängt Klicks auf Konto-Links ab und zeigt vor der Weiterleitung ein kurzes Panel.
 * Delegierter document-Listener statt Verdrahtung im Header: deckt Header-Service-Leiste,
 * Footer-Spalte „Mein Konto" und Mobile-Drawer gleichzeitig ab, überlebt DOM-Swaps
 * (Section-Rendering, Drawer-Neuaufbau) und erfordert keine Änderung an lmm-header.liquid.
 *
 * Bewusst NICHT abgefangen: Modifier-/Mittelklicks (neuer Tab), Logout-Links und alles,
 * was bereits in einem Panel liegt. Ohne dieses Skript funktionieren die Links normal.
 */
(function () {
  'use strict';
  if (window.__lmmLoginHintInit) { return; }
  window.__lmmLoginHintInit = true;

  var SEL_ROOT = '[data-lmm-login-hint]';
  var lastTrigger = null;
  var targetHref = null;

  function root() { return document.querySelector(SEL_ROOT); }

  /* Ist das ein Link auf die Kundenanmeldung?
     Deckt den relativen Theme-Pfad (/account…) und die gehostete Variante
     (shopify.com/<shop-id>/account…) ab. Logout ist ausgenommen. */
  function isAccountLink(a) {
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') { return false; }
    var path;
    try { path = new URL(a.href, window.location.origin).pathname; } catch (e) { return false; }
    if (path.indexOf('/account') === -1) { return false; }
    if (path.indexOf('logout') !== -1) { return false; }
    return true;
  }

  function place(trigger) {
    var el = root();
    if (!el) { return; }
    var panel = el.querySelector('.lmm-lgh__panel');
    if (!panel) { return; }
    // Mobil positioniert das CSS das Sheet selbst — hier nichts rechnen.
    if (window.matchMedia('(max-width: 640px)').matches) {
      panel.style.top = '';
      panel.style.left = '';
      return;
    }
    var r = trigger.getBoundingClientRect();
    var w = panel.offsetWidth;
    var margin = 12;
    // unter dem Auslöser, rechtsbündig — aber immer im Viewport halten
    var left = Math.min(Math.max(margin, r.right - w), window.innerWidth - w - margin);
    var top = r.bottom + 10;
    var maxTop = window.innerHeight - panel.offsetHeight - margin;
    if (top > maxTop) { top = Math.max(margin, maxTop); }
    panel.style.left = Math.round(left) + 'px';
    panel.style.top = Math.round(top) + 'px';
  }

  function open(trigger, href) {
    var el = root();
    if (!el) { return; }
    lastTrigger = trigger;
    targetHref = href;
    var go = el.querySelector('[data-lmm-lgh-go]');
    if (go && href) { go.setAttribute('href', href); }
    el.hidden = false;
    place(trigger);
    if (go) { go.focus(); }
  }

  function close(restoreFocus) {
    var el = root();
    if (!el || el.hidden) { return; }
    el.hidden = true;
    if (restoreFocus && lastTrigger && document.contains(lastTrigger)) { lastTrigger.focus(); }
    lastTrigger = null;
    targetHref = null;
  }

  document.addEventListener('click', function (ev) {
    var el = root();
    if (!el) { return; }

    // Schließen-Kreuz
    if (ev.target.closest && ev.target.closest('[data-lmm-lgh-close]')) {
      ev.preventDefault();
      close(true);
      return;
    }

    // Klick auf den Layer neben dem Panel schließt
    if (!el.hidden && ev.target === el) {
      close(true);
      return;
    }

    var a = ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) { return; }

    // Der CTA im Panel selbst navigiert normal weiter
    if (a.hasAttribute('data-lmm-lgh-go')) { return; }
    if (el.contains(a)) { return; }

    // Neuer Tab / neues Fenster: nicht eingreifen
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) { return; }
    if (a.target && a.target !== '' && a.target !== '_self') { return; }

    if (!isAccountLink(a)) { return; }

    ev.preventDefault();
    open(a, a.href);
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' || ev.key === 'Esc') { close(true); }
  });

  window.addEventListener('resize', function () {
    var el = root();
    if (el && !el.hidden && lastTrigger) { place(lastTrigger); }
  });

  window.addEventListener('scroll', function () {
    var el = root();
    if (el && !el.hidden && lastTrigger && !window.matchMedia('(max-width: 640px)').matches) {
      place(lastTrigger);
    }
  }, { passive: true });
})();
